import { ResolveFn } from '@angular/router';
import { Lane } from './lane-types';

// One lazy chunk per Indian port, so a lane page only downloads the lanes for its own origin.
const LANE_DATA: Record<string, () => Promise<Lane[]>> = {
  chennai: () => import('./data/chennai').then(m => m.LANES),
  kattupalli: () => import('./data/kattupalli').then(m => m.LANES),
  ennore: () => import('./data/ennore').then(m => m.LANES),
  tuticorin: () => import('./data/tuticorin').then(m => m.LANES),
  kochi: () => import('./data/kochi').then(m => m.LANES),
  'nhava-sheva': () => import('./data/nhava-sheva').then(m => m.LANES),
  mundra: () => import('./data/mundra').then(m => m.LANES),
  pipavav: () => import('./data/pipavav').then(m => m.LANES),
  kolkata: () => import('./data/kolkata').then(m => m.LANES),
  visakhapatnam: () => import('./data/visakhapatnam').then(m => m.LANES),
};

// A resolver, not ngOnInit: the router waits for it, so server rendering always has the data.
// The route's canMatch has already checked the lane exists.
// lane-copy is imported on demand: it pulls in the lane index, which should stay out of the main bundle.
export const laneResolver: ResolveFn<Lane | undefined> = async route => {
  const { LANE_PREFIX } = await import('./lane-copy');
  const origin = route.paramMap.get('port') ?? '';
  const dest = (route.paramMap.get('lane') ?? '').slice(LANE_PREFIX.length);
  const lanes = await (LANE_DATA[origin]?.() ?? Promise.resolve([] as Lane[]));
  return lanes.find(l => l.dest === dest);
};
